<template>
  <div>
    <section class="bg-color-">
      <div class="container">
        <h1>Assign Role</h1>
      </div> <!-- /. container -->
    </section> <!-- /. section -->
  </div> <!-- /. root div -->
</template>
<script>
export default {
  name: "Blankpage",
  components:{},
  data: () => ({}),
  methods: {},
  watch: {},
};
</script>
<style scoped>

@media (min-width: 320px) and (max-width: 767.98px) { 

}
@media (min-width: 768px) and (max-width: 991.98px) {

}
@media (min-width: 992px) and (max-width: 1024px) { 
}

</style>
